import React from 'react'
import { BasicStyledComponent, DSFieldNumber } from 'shared-definitions/types'
import styles from './FieldNumber.module.css'
import clsx from 'clsx'

interface FieldNumberProps extends BasicStyledComponent {
  field: DSFieldNumber
  onChange: (value: string) => void
  onBlur?: () => void
  value: string
}

export const FieldNumber: React.FC<FieldNumberProps> = ({
  field,
  className,
  onBlur,
  onChange,
  value,
}) => (
  <div className={clsx(className, styles.container)}>
    {field.prefix && <div className={styles.prefix}>{field.prefix}</div>}
    <div className={styles.inputWrapper}>
      <input
        required={field.required}
        name={field.name}
        type="number"
        className={styles.input}
        min={field.min?.toString()}
        max={field.max?.toString()}
        value={value}
        onBlur={onBlur}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  </div>
)
